<template>
    <BreadCrumb PageTitle="Modifier un devoir" />
    <EditDevoir/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditDevoir from "../../components/Devoir/EditDevoir.vue";

    export default defineComponent({
      name: "EditDevoirPage",
      components: {
        BreadCrumb,
        EditDevoir,
      },
    });
  </script>